// Grid-code family route (/admin/datasets/families/$familyId): the tab (versions, sections, settings, history) in the URL; the screen is FamilyPage.
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { enumWithDefault } from "@/app/search";
import { FamilyPage } from "@/features/datasets/FamilyPage";

const FAMILY_TABS = ["versions", "sections", "settings", "history"] as const;

const searchSchema = z.object({
  tab: enumWithDefault(FAMILY_TABS, "versions"),
});

export const Route = createFileRoute("/_app/admin/datasets/families/$familyId/")({
  validateSearch: searchSchema,
  staticData: { crumb: "Grid code" },
  component: FamilyPage,
});
